const contactForm = () => {
  const forms = document.querySelectorAll(".wpcf7-form");
  if (!forms.length) return;

  const isFormValid = (form) => {
    // CF7 non usa l'attributo required: controllo manuale dei campi obbligatori
    const required = form.querySelectorAll(".wpcf7-validates-as-required");
    for (const field of required) {
      if (field.matches("input, textarea, select")) {
        if (!field.value.trim()) return false;
      } else if (!field.querySelector("input:checked")) {
        // gruppi checkbox / radio
        return false;
      }
    }

    const acceptances = form.querySelectorAll(".wpcf7-acceptance:not(.optional) input[type='checkbox']");
    for (const checkbox of acceptances) {
      if (!checkbox.checked) return false;
    }

    // formato email, url, ecc.
    return [...form.querySelectorAll("input, textarea, select")].every((field) => field.checkValidity());
  };

  forms.forEach((form) => {
    const update = () => form.classList.toggle("is-valid", isFormValid(form));
    form.addEventListener("input", update);
    form.addEventListener("change", update);
    form.addEventListener("reset", () => setTimeout(update));
    form.closest(".wpcf7")?.addEventListener("wpcf7submit", update);
    update();
  });
};

export default contactForm;
